import { academyApi, type B2gContractSignatureBody } from '@mathflat/domain/Academy'

import { B2gContract } from '@/dto/B2g/B2gContract'

class ContractController {
  // crm에서 전송한 계약서 정보
  async fetchContractInfo() {
    const contract = await academyApi.getB2gContract({
      mp_event_name: 'T61-02_b2g계약서_정보조회_API',
    })
    return new B2gContract(contract ?? undefined)
  }
  // 계약서 제출
  async submitContract(data: B2gContractSignatureBody) {
    await academyApi.signB2gContract(data, { mp_event_name: 'T61-01_b2g계약서_제출_API' })
  }
  // 계약서 다운로드
  async downloadContractPdf() {
    return academyApi.getB2gContractPdf({ mp_event_name: 'T61-03_b2g계약서_다운로드_API' })
  }
}
export const contractController = new ContractController()
